const config = {
  vaix: {
    nameId: 'origin-vaix',
    originString: 'Vaix'
  }
}

function getOriginForElement (el) {
  if (!el) return ''

  const originId = getClosestOriginId(el, getAllOriginNameIds())
  return getOriginString(originId)
}

function getAllOriginNameIds () {
  let result = []

  Object.keys(config).forEach(key => {
    let item = config[key]
    result.push(item.nameId)
  })

  return result
}

function getClosestOriginId (el, classList) {
  let result = ''

  const selectorForAllOriginIds = classList
                    .map(cls => `.${cls}`)
                    .join(', ')

  const closestElement = selectorForAllOriginIds ? el.closest(selectorForAllOriginIds) : null

  if (closestElement) {
    result = classList.find(cls => closestElement.classList.contains(cls))
  }

  return result
}

function getOriginString (nameId) {
  let result = ''

  if (!nameId) return result

  Object.keys(config).forEach(key => {
    let item = config[key]

    if (item.nameId === nameId) {
      result = item.originString
    }
  })

  return result
}

export default {
  config,
  getOriginForElement
}



// WEBPACK FOOTER //
// ./src/library/origin.js